import axios from 'axios';

export const fetchAuditor = (projectId, auditorId) => axios.get(`/projects/${projectId}/auditors/${auditorId}`);
export const fetchAuditorVisits = (projectId, auditorId, params = {}) => axios.get(`/projects/${projectId}/auditors/${auditorId}/visits`, { params });
